// extracted by mini-css-extract-plugin
export var emailBlockLink = "_kg-0";